module.exports = __webpack_public_path__ + "static/media/new-logo-4-bg.594ae97e.png";